import { useState, type FormEvent } from 'react'

import { useAppStore } from '@/store/useAppStore'
import { LogoMark } from '@/components/layout/Logo'
import { Spinner } from '@/components/common/Spinner'
import { AlertIcon, LockIcon } from '@/components/common/icons'

export function TokenGate() {
  const login = useAppStore((s) => s.login)
  const [token, setToken] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function onSubmit(ev: FormEvent) {
    ev.preventDefault()
    if (busy) return
    setBusy(true)
    setError(null)
    const result = await login(token)
    if (!result.ok) {
      setError(result.error)
      setToken('')
    }
    setBusy(false)
  }

  return (
    <div className="gate">
      <form className="card card--pad gate__card" onSubmit={onSubmit}>
        <LogoMark size={56} className="gate__logo" />
        <h1 className="gate__title">FRAM Control&nbsp;Plane</h1>
        <p className="gate__text">
          Доступ к панели управления защищён токеном. Введите токен оператора, чтобы
          увидеть живые данные парсера.
        </p>

        <div className="gate__form">
          <div className="field">
            <label className="field__label" htmlFor="token">
              Токен доступа
            </label>
            <div className="input">
              <LockIcon size={16} className="input__icon" />
              <input
                id="token"
                type="password"
                autoComplete="off"
                autoFocus
                placeholder="вставьте токен"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                aria-invalid={error !== null}
              />
            </div>
          </div>

          {error ? (
            <div className="gate__error" role="alert">
              <AlertIcon size={15} />
              <span>{error}</span>
            </div>
          ) : null}

          <button type="submit" className="btn btn--primary btn--block" disabled={busy || !token.trim()}>
            {busy ? <Spinner size={15} className="btn__spin" /> : <LockIcon size={16} />}
            {busy ? 'Проверка…' : 'Войти'}
          </button>
        </div>

        <p className="gate__foot">
          Токен хранится только в памяти вкладки и нигде не сохраняется. Соединение
          должно идти по защищённой ссылке (HTTPS).
        </p>
      </form>
    </div>
  )
}
